export default {
    primaryColor: "#8A9DBC",
    background: "#FFFDFD", 
    tertiary: "#404e78",
    darkText: "#222E50"
}